export default function Logo() {
  return (
    <img title="To do App - Logo" className="h-6" src="/assets/images/logo.svg" alt="To do App - Logo" />
  )
}
